import { render, staticRenderFns } from "./DadosPadraoTriagem.vue?vue&type=template&id=38b822a6"
import script from "./DadosPadraoTriagem.vue?vue&type=script&lang=ts"
export * from "./DadosPadraoTriagem.vue?vue&type=script&lang=ts"
import style0 from "./DadosPadraoTriagem.vue?vue&type=style&index=0&id=38b822a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports